var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.33 50.51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 50.51v-11.87h3v-26.77h-3v-11.87h31.08l8.25 8.38v12.77l-3.19 3.19 3.19 3.19v14.61l-8.25 8.37zm23.77-11.87 1.35-1.28v-5.76l-1.38-1.38h-6.49v8.42zm0-20.15 1.36-1.29v-4l-1.35-1.3h-6.53v6.62z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.52 49v-8.84h3v-29.81h-3v-8.83h28.9l7.39 7.48v11.5l-3.81 3.84 3.84 3.84v13.33l-7.42 7.49zm22.89-8.83 2.22-2.17v-7l-2.23-2.3h-8.67v11.46zm0-20.15 2.22-2.16v-5.34l-2.21-2.17h-8.69v9.65z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.29 9.66-6.53-6.66h-26.76v5.83h3v32.85h-3v5.79h26.76l6.53-6.6v-12l-4.48-4.49 4.48-4.49zm-8.14 29-3.09 3h-10.85v-14.47h10.85l3.09 3.13zm0-20.16-3.09 3h-10.85v-12.67h10.85l3.09 3z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.f2264b3194a47968e3d5a292f209743f.svg";
export { ForwardRef as ReactComponent };